import { useState } from "react";
import { ArrowLeft } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { DateFilterKey } from "@/utils/dateFilters";
import { UserOrganizationRole } from "@blinkbooks/types";
import ProfitAndLossCard from "./ProfitAndLossCard";
import ProfitAndLossStatement from "./ProfitAndLossStatement";

interface ReportsProps {
  dateFilterKey: DateFilterKey | "";
  dateCustomFrom?: Date;
  dateCustomTo?: Date;
  onDateFilterChange: (key: DateFilterKey | "", from?: Date, to?: Date) => void;
  role?: UserOrganizationRole | null;
}

type ReportKey = "profit-loss";

const Reports = ({ dateFilterKey, dateCustomFrom, dateCustomTo, onDateFilterChange, role }: ReportsProps) => {
  const [openReport, setOpenReport] = useState<ReportKey | null>(null);

  return (
    <Card className="m-6 shadow-md">
      <CardHeader>
        <div className="flex items-center gap-3">
          {openReport && (
            <button
              onClick={() => setOpenReport(null)}
              className="flex items-center justify-center w-8 h-8 rounded-md hover:bg-muted/60 transition-colors shrink-0"
              aria-label="Back to reports"
            >
              <ArrowLeft className="h-4 w-4 text-muted-foreground" />
            </button>
          )}
          <div>
            <CardTitle>Reports</CardTitle>
            <p className="text-sm text-muted-foreground mt-1">
              {openReport ? "Full statement, consolidated across every connected entity." : "Financial statements, consolidated across every connected entity."}
            </p>
          </div>
        </div>
      </CardHeader>
      <CardContent>
        {!openReport && (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            <ProfitAndLossCard
              dateFilterKey={dateFilterKey}
              dateCustomFrom={dateCustomFrom}
              dateCustomTo={dateCustomTo}
              onOpen={() => setOpenReport("profit-loss")}
            />
          </div>
        )}

        {openReport === "profit-loss" && (
          <ProfitAndLossStatement
            dateFilterKey={dateFilterKey}
            dateCustomFrom={dateCustomFrom}
            dateCustomTo={dateCustomTo}
            onDateFilterChange={onDateFilterChange}
            role={role}
          />
        )}
      </CardContent>
    </Card>
  );
};

export default Reports;
